<template>
    <div>
        <div v-if="!detailsSubmitted">
            <span class="text-muted">{{ __('sale.stripe.onboarding_info') }}</span>
            <div class="text-center my-7">
                <button class="d-inline-block btn btn-light-warning" @click.prevent="updateStripeAccount">
                    <i class="fas fa-arrow-alt-circle-right"/>
                    {{ __('actions.continue_setup_of_thing', {thing: 'Stripe'}) }}
                </button>
            </div>
        </div>
        <div v-else-if="detailsSubmitted && !chargesEnabled">
            <span class="text-muted">
                {{ __('sale.stripe.dashboard_info') }}
            </span>
            <a target="_blank" href="https://dashboard.stripe.com/dashboard">
                <button class="d-inline-block btn btn-sm stripe-connect pr-0 my-7">
                    <span>{{ __('sale.stripe.dashboard') }}</span>
                </button>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UpdateStripeAccount',

    props: {
        detailsSubmitted: Boolean,
        chargesEnabled: Boolean,
    },

    methods: {
        updateStripeAccount() {
            axios.post(this.$route('update.stripe.account', {
                storeUuid: this.$page.props.storeUuid,
            })).then(response => {
                window.open(response.data['link'], '_blank')
            })
        },
    },
}
</script>
